import React from 'react';

import APModal from 'components/Modal/APModal';

export const InactivityModal = (props) => {
  const {
    time,
    dismissInactivityModal,
    resetTimer,
  } = props;

  const dismiss = () => {
    resetTimer();
    dismissInactivityModal();
  };

  if (time <= 0) {
    return (
      <APModal
        open
        onClose={dismissInactivityModal}
        name="note-inactivity"
        title="Heads up!"
        actions={(
          <button
            type="button"
            className="button"
            onClick={dismissInactivityModal}
          >
            Ok
          </button>
        )}
      >
        Your note has closed due to inactivity.
      </APModal>
    );
  }

  return (
    <APModal
      open
      onClose={dismiss}
      title="Are you still there?"
      name="note-inactivity"
      actions={(
        <button
          type="button"
          className="button"
          onClick={dismiss}
        >
          Keep editing
        </button>
      )}
    >
      Your note will close automatically in {time} seconds.
      This will unlock the note and allow others to edit it. Click the
      button to keep editing your note.
    </APModal>
  );
};

